var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.367,
    height: 20.367,
    viewBox: "0 0 20.367 20.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2609",
    "data-name": "Group 2609",
    transform: "translate(-100.919 -727.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(100.919 727.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2606",
    "data-name": "Group 2606",
    transform: "translate(9.395 4.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2605",
    "data-name": "Group 2605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3350",
    "data-name": "Path 3350",
    d: "M240.586,126.036l-2.84-2.13v-4.338a.789.789,0,0,0-1.578,0V124.3a.787.787,0,0,0,.316.631l3.155,2.366a.789.789,0,0,0,.947-1.262Z",
    transform: "translate(-236.169 -118.779)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2608",
    "data-name": "Group 2608",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2607",
    "data-name": "Group 2607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3351",
    "data-name": "Path 3351",
    d: "M10.184,0A10.184,10.184,0,1,0,20.367,10.184,10.195,10.195,0,0,0,10.184,0Zm0,18.79a8.606,8.606,0,1,1,8.606-8.606A8.617,8.617,0,0,1,10.184,18.79Z",
    transform: "translate(0)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.a4bc2d509e0aba15c722e62c21b69591.svg";
export { ForwardRef as ReactComponent };